<template>
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Close">
      <path
        d="M0.437546 2.55001C-0.145803 1.96666 -0.145803 1.02086 0.437546 0.437515C1.02089 -0.145835 1.96669 -0.145835 2.55004 0.437515L21.5625 19.45C22.1458 20.0333 22.1458 20.9791 21.5625 21.5625C20.9791 22.1458 20.0333 22.1458 19.45 21.5625L0.437546 2.55001Z"
        :fill="color"
      />
      <path
        d="M19.45 0.437513C20.0333 -0.145837 20.9791 -0.145838 21.5625 0.437512C22.1458 1.02086 22.1458 1.96666 21.5625 2.55001L2.55001 21.5625C1.96666 22.1458 1.02086 22.1458 0.437512 21.5625C-0.145837 20.9791 -0.145837 20.0333 0.437512 19.45L19.45 0.437513Z"
        :fill="color"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "IconBigCross",
  props: {
    color: {
      default: "#F18E35",
    },
  },
};
</script>

<style scoped></style>
